import { IStyleProps } from './Interface'
import { makeStyles, Theme } from '@material-ui/core/styles'

export default makeStyles<Theme, IStyleProps>(theme => ({
  root: ({ selected, color }) => ({
    color: theme?.palette?.common?.darkGrey,
    backgroundColor: 'unset',
    cursor: 'pointer',
    '&:focus': {
      color: selected ? theme?.palette?.common?.white : theme?.palette?.common?.darkGrey,
      backgroundColor: selected ? color : 'unset'
    },

    [theme.breakpoints.up('md')]: {
      '&&:hover': {
        color: theme?.palette?.common?.darkGrey,
        backgroundColor: theme?.palette?.common?.lightGrey,
        borderColor: 'transparent'
      }
    }
  }),
  pending: ({ color }) => ({
    color,
    border: `1px solid ${color}`,
    '&:focus': {
      color,
      border: `1px solid ${color}`,
      backgroundColor: theme?.palette?.common?.white
    }
  }),
  active: ({ color }) => ({
    color: theme?.palette?.common?.white,
    backgroundColor: color
  })
}))
